// Folder bindings. Mirrors iOS FoldersEndpoints + /folders/* and the co-located
// PATCH /question-sets/{id}/folder assignment route.
import { api } from "./client";

export interface FolderRead {
  id: string;
  name: string;
  color: string;
  sort_order: number;
}

export function listFolders(): Promise<FolderRead[]> {
  return api.get<FolderRead[]>("/folders/");
}

export function createFolder(name: string, color = "blue"): Promise<FolderRead> {
  return api.post<FolderRead>("/folders/", { name, color, sort_order: 0 });
}

export function deleteFolder(id: string): Promise<void> {
  return api.delete<void>(`/folders/${encodeURIComponent(id)}`);
}

/** Assign a set to a folder, or pass null to clear (un-file). */
export function assignSetFolder(setId: string, folderId: string | null): Promise<unknown> {
  return api.patch(`/question-sets/${encodeURIComponent(setId)}/folder`, {
    folder_id: folderId,
  });
}
